import PropTypes from 'prop-types';
import { Box, Stack } from '@mui/material';
import { SideNavItem } from './side-nav-item';

const defaultLeafActive = (pathname, path) => {
  if (!path) return false;
  return pathname === path || pathname.startsWith(`${path}/`);
};

const isLeafActive = (item, pathname) => {
  if (item.isActivePath) return item.isActivePath(pathname);
  return defaultLeafActive(pathname, item.path);
};

const branchHasActiveDescendant = (item, pathname) => {
  if (!item.items || !item.items.length) return false;
  return item.items.some((child) => {
    if (child.items) return branchHasActiveDescendant(child, pathname);
    return isLeafActive(child, pathname);
  });
};

const branchActive = (item, pathname) => {
  if (item.path && pathname.includes(item.path)) {
    return true;
  }
  return branchHasActiveDescendant(item, pathname);
};

const itemKey = (item, depth) => `${depth}-${item.path || item.title}-${item.key || ''}`;

const renderItems = ({ depth = 0, items, pathname }) =>
  items.reduce(
    (acc, item) =>
      reduceChildRoutes({
        acc,
        depth,
        item,
        pathname,
      }),
    []
  );

const reduceChildRoutes = ({ acc, depth, item, pathname }) => {
  if (item.items) {
    const branchIsActive = branchActive(item, pathname);
    acc.push(
      <SideNavItem
        active={branchIsActive}
        depth={depth}
        disabled={item.disabled}
        icon={item.icon}
        key={itemKey(item, depth)}
        label={item.label}
        open={branchIsActive}
        path={item.path}
        title={item.title}
      >
        <Stack
          component="ul"
          spacing={0.5}
          sx={{
            listStyle: 'none',
            m: 0,
            p: 0,
          }}
        >
          {renderItems({
            depth: depth + 1,
            items: item.items,
            pathname,
          })}
        </Stack>
      </SideNavItem>
    );
  } else {
    acc.push(
      <SideNavItem
        active={isLeafActive(item, pathname)}
        depth={depth}
        disabled={item.disabled}
        icon={item.icon}
        key={itemKey(item, depth)}
        label={item.label}
        path={item.path}
        title={item.title}
      />
    );
  }

  return acc;
};

export const SideNavSection = (props) => {
  const { items = [], pathname, subheader = '', ...other } = props;

  return (
    <Stack
      component="ul"
      spacing={0.5}
      sx={{
        listStyle: 'none',
        m: 0,
        p: 0,
      }}
      {...other}
    >
      {subheader && (
        <Box
          component="li"
          sx={{
            color: 'var(--nav-section-title-color)',
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.66,
            mb: 1,
            ml: 1,
            textTransform: 'uppercase',
          }}
        >
          {subheader}
        </Box>
      )}
      {renderItems({ items, pathname })}
    </Stack>
  );
};

SideNavSection.propTypes = {
  items: PropTypes.array,
  pathname: PropTypes.string,
  subheader: PropTypes.string,
};
